import type { ComponentProps } from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { cn } from "@/lib/utils";

export function ToggleGroup({
  className,
  ...props
}: ComponentProps<typeof ToggleGroupPrimitive.Root>) {
  return (
    <ToggleGroupPrimitive.Root
      className={cn("inline-flex items-center rounded-full border border-ink/25 bg-transparent p-px", className)}
      {...props}
    />
  );
}

export function ToggleGroupItem({ className, ...props }: ComponentProps<typeof ToggleGroupPrimitive.Item>) {
  return (
    <ToggleGroupPrimitive.Item
      className={cn(
        "h-8 rounded-full border border-transparent px-3.5 text-sm font-normal text-muted transition-colors hover:text-ink focus-visible:border-focus focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus data-[state=on]:border-ink data-[state=on]:bg-ink data-[state=on]:text-canvas pointer-coarse:h-11",
        className,
      )}
      {...props}
    />
  );
}
